import React, {useState} from 'react'
import {useSelector} from "react-redux";
import axios from "axios";

const LeadCount = () => {
  const imageMap = useSelector((state) => state.imageMap)
  const [amount, setAmount] = useState()
  axios.get(`/image_maps/${imageMap?.id}/lead_exports/generated_leads`)
    .then((data) => setAmount(data.data.amount))

  console.log({amount})
  if (amount) {
    return <p>
      There are <span className="badge badge-pill badge-colored">{amount}</span> generated leads.
    </p>
  }

  return null;
}

export default function Leads() {
  const hostname = useSelector(state => state.hostname)
  const imageMap = useSelector((state) => state.imageMap)

  console.log({imageMap})

  // const contactsUrl = useSelector(state => state.leadGenerationUrl) + ".xlsx"

  return <div>
    <div className="row">
      {/*<div className="col-md-6">*/}
      {/*  <div className="shadow m-2 p-2">*/}
      {/*    <h4>LEADS</h4>*/}
      {/*    <p>Here you find leads generated by you so far. To download a .xls file just press the button below.</p>*/}
      {/*    <a download={true} href={contactsUrl} className="btn-ueg">*/}
      {/*      Download XLS*/}
      {/*    </a>*/}
      {/*  </div>*/}
      {/*</div>*/}

      {(hostname === "flaveueg22" || hostname === "flaveueg23")  && <div className="col-md-6">
        <div className="shadow m-2 p-2">
          <h4>LEADS</h4>
          <LeadCount/>
          <p>Here you find leads generated by you so far. To download a .xls file just press the button below.</p>
          <a download={true} href={`/image_maps/${imageMap?.id}/lead_exports`} className="btn-ueg">
            Download XLS
          </a>
        </div>
      </div>}
    </div>
  </div>;
}
